import * as React from "react";
import { renderMbnIcon } from "../../EventCard/RenderMethods/renderMbnIcon";
import { renderMarketsCount } from "./renderMarketsCount";
export const renderIconsWrapper = (marketLinesCount, tagNumber, isDesktop, componentPrefix) => React.createElement("div", { className: `rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__icons-holder`, "data-uat": `div-ev-list-${componentPrefix}-icons-holder` },
    renderMbnIcon(tagNumber),
    !isDesktop && renderMarketsCount(marketLinesCount, componentPrefix));
//# sourceMappingURL=renderIconsWrapper.js.map